<template>
  <section>
    <p class="nameLabel">
      {{ getOperatorLabel }} <strong> {{ formatFieldName }} </strong> must be
    </p>
    <InputText
      :autofocus="false"
      class="fieldInput"
      :isDisabled="false"
      :isReadonly="false"
      :required="false"
      :showValidationMessage="false"
      :value="listItem.value"
      @input="updateLineItem"
    />
  </section>
</template>

<script>
import { InputText } from '@jumpcloud/ui-components';
import Util from 'client/util/Util';

const { convertPascalCaseToWords } = Util;

export default {
  name: 'MembershipSuggestionRuleFields',

  components: {
    InputText,
  },

  inject: ['$validator'],

  props: {
    handleChangeListItem: {
      type: Function,
      default: () => {},
    },
    index: {
      type: Number,
      default: undefined,
    },
    listItem: {
      type: Object,
      default: null,
    },
  },

  computed: {
    formatFieldName() {
      return convertPascalCaseToWords(this.listItem.field, 'remove');
    },

    getOperatorLabel() {
      return this.index === 0 ? '' : 'and ';
    },
  },

  methods: {
    updateLineItem(value) {
      this.handleChangeListItem({
        ...this.listItem, value,
      }, 'value');
    },
  },
};
</script>

<style scoped>
.nameLabel {
  margin: 0;
  padding: 0;
}

.fieldInput {
  width: calc(75% - 5px) !important;
}
</style>
